import { IRateStatus } from '@cai-services';
import { AirlineBrand } from './airline.model';

export class RateStatus implements IRateStatus {
  id: number;
  airlineBrand: AirlineBrand;
  countryCode: string;
  isActive: boolean;
  isExpressActive: boolean;

  constructor(
    airlineBrand: AirlineBrand,
    countryCode?: string,
    isActive?: boolean,
    isExpressActive?: boolean,
  ) {
    this.airlineBrand = airlineBrand;
    this.countryCode = countryCode;
    this.isActive = isActive || false;
    this.isExpressActive = isExpressActive || false;
  }
}
